/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BREAKPOINTS */
/* unused harmony export DAYS */
/* unused harmony export API_DOMAIN_DEFAULT */
/* unused harmony export API_COMMUNITY_DOMAIN */
/* unused harmony export STATIC_DOMAIN_DEFAULT */
/* unused harmony export STATIC_CDN_DOMAIN_DEFAULT */
/* unused harmony export NO_ITEM_IMAGE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PET_NECKLACE_ID; });
var BREAKPOINTS = {
  tablet: 640,
  pc: 960,
  max: 1340
};

var DAYS = {
  'Sunday': '일',
  'Monday': '월',
  'Tuesday': '화',
  'Wednesday': '수',
  'Thursday': '목',
  'Friday': '금',
  'Saturday': '토'
};

var API_DOMAIN_DEFAULT = 'https://api-lineage.plaync.com';

var API_COMMUNITY_DOMAIN = 'https://api-commnity.plaync.com/lineage1';

var STATIC_DOMAIN_DEFAULT = 'https://assets.playnccdn.com'; // https://wstatic.plaync.co.kr';

var STATIC_CDN_DOMAIN_DEFAULT = 'https://wstatic-cdn.plaync.com';

var NO_ITEM_IMAGE_URL = STATIC_DOMAIN_DEFAULT + '/lineage/v1/img/world/item/noimg.gif';

var PET_NECKLACE_ID = 25668;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduleTable__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_model__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_service__ = __webpack_require__(7);





(function ($, global) {
  "use strict";

  var scheduleTable = null;
  var contiGroupData = {};

  Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["b" /* namespace */])('nc.lineage');

  nc.lineage.schedule = function (options) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["a" /* isNotDefined */])(options)) throw new Error('nc.lineage.schedule require options object');

    // console.log( ' schedule.js  options : ', options );
    options.wrap.append('<div class="loadingbar"></div>');
    init();

    function init() {
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_service__["a" /* getDatasWithOption */])([{
        type: 'GET',
        url: options.apiDomain + '/conti/getContentGroup?service=lineage&groupAlias=lineage-schedule&subAlias=ko-KR',
        dataType: 'json',
        contentType: 'application/json',
        Accept: 'application/json'
      }], function (data) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["c" /* not */])(Array.isArray)(data) || data.length <= 0) {
          console.log('error : no data');
        } else {
          data.forEach(function (item) {
            if (item.alias === 'schedule-table') contiGroupData.table = JSON.parse(item.jsonData);
            if (item.alias === 'schedule-content') contiGroupData.content = JSON.parse(item.jsonData);
          });
          // console.log( ' schedule.js  contiGroupData : ', contiGroupData );
          setInstance();
        }
      }, function (data) {
        console.log('error : rejected');
      });
    }

    function setInstance() {
      scheduleTable = new __WEBPACK_IMPORTED_MODULE_0__ScheduleTable__["a" /* default */]({
        now: options.now,
        wrap: options.wrap,
        apiDomain: options.apiDomain,
        timeData: contiGroupData.table,
        timeTableData: contiGroupData.content
      }).init();
    }
  };
})(jQuery, window);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduleTableTpl__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ScheduleTable = function () {
    function ScheduleTable(options) {
        _classCallCheck(this, ScheduleTable);

        this.option = options;
        console.log(' schedule.js constructor() options : ', options);

        var _now = new Date(this.option.now);
        var currentDate = { year: _now.getFullYear(), month: _now.getMonth() + 1, day: _now.getDate(), hour: _now.getHours(), minute: _now.getMinutes(), dayOfWeek: _now.getDay() };

        this.wrap = this.option.wrap;
        this.currentDate = currentDate;
        this.standardDate = currentDate;
        this.PC_WIDTH = 960;
        this.SELECTED_COL = currentDate.dayOfWeek;
        this.objByTime = {};
        this.timer = null;
    }

    _createClass(ScheduleTable, [{
        key: 'init',
        value: function init() {

            console.log('# schedule.js init()');
            $(this.wrap).empty();
            this.sortData();

            $('.loadingbar', this.wrap).remove();

            this.drawTable();
            this.setEvent();
            this.setFooter();
        }
    }, {
        key: 'sortData',
        value: function sortData() {
            var _this = this;

            // 데이터 재배열 (요일순 > 시간순 정렬)
            var objByAlias = {},
                objTemp = {};

            $.each(this.option.timeTableData.data, function (index, value) {
                objByAlias[value.alias] = value;
            });

            console.log(' SecheduleTable.js sortData() this.option.timeData.timeTable : ', this.option.timeData.timeTable);
            console.log(' SecheduleTable.js sortData() this.option.timeTableData.data : ', this.option.timeTableData.data);

            $.each(this.option.timeData.timeTable, function (key, value) {
                for (var i = 0; i < value.length; i++) {
                    if (!value[i].boxAlias) continue;
                    var item = objByAlias[value[i].boxAlias];
                    if (!item) continue;

                    if (!objTemp[item.startTime]) {
                        objTemp[item.startTime] = { 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [] }; // (1~7) = (월~일)로 표기 통일
                    }
                    objTemp[item.startTime][key].push(item);
                }
            });

            Object.keys(objTemp).sort().forEach(function (key) {
                _this.objByTime[key] = objTemp[key];
            });

            console.log(' SecheduleTable.js sortData() objTemp : ', objTemp);
        }
    }, {
        key: 'drawTable',
        value: function drawTable() {
            console.log('drawTable() this.objByTime : ', this.objByTime);

            $(this.wrap).append(__WEBPACK_IMPORTED_MODULE_0__ScheduleTableTpl__["a" /* default */].getTpl({
                currentDate: this.currentDate,
                standardDate: this.standardDate,
                objByTime: this.objByTime
            }));
        }
    }, {
        key: 'setEvent',
        value: function setEvent() {
            var _this2 = this;

            // Width값에 따른 모바일/PC UI
            $(window).on('resize', function (e) {
                if (_this2.timer) {
                    clearTimeout(_this2.timer);
                    _this2.timer = null;
                }
                _this2.timer = setTimeout(function () {
                    return _this2.resizeTable($(e.target).width());
                }, 300);
            });
            this.resizeTable($(window).width());

            // 모바일 해상도 요일 클릭 이벤트
            $('.schedule-table-head li', this.wrap).click(function (e) {
                var width = $(window).width();
                var target = $(e.currentTarget)[0];
                if (width >= _this2.PC_WIDTH) {
                    return false;
                }
                _this2.SELECTED_COL = $(target).index() + 1;
                $(target).siblings().removeClass('selected');
                $(target).addClass('selected');
                _this2.resizeTable(width);
            });
        }
    }, {
        key: 'resizeTable',
        value: function resizeTable() {
            var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            // 저해상도에서 1개의 선택된 요일 column만 노출
            if (width < this.PC_WIDTH) {
                $('.schedule-table-body li', this.wrap).removeClass('show');
                $('.schedule-table-body li:nth-child(' + this.SELECTED_COL + ')', this.wrap).addClass('show');
            }
        }
    }, {
        key: 'setFooter',
        value: function setFooter() {
            var scheduleFooter = '\n        <div class="schedule-footer">\n            <ul class="schedule-footer-typelist">\n                <li class="type-red interserver">\uC778\uD130\uC11C\uBC84</li>\n                <li class="type-green localserver">\uB85C\uCEEC\uC11C\uBC84</li>\n                <li class="type-blue event">\uC774\uBCA4\uD2B8</li>\n            </ul>\n            <p class="schedule-footer-noti">\uC2A4\uCF00\uC904\uD45C \uD074\uB9AD\uC2DC \uD574\uB2F9 \uCF58\uD150\uD2B8\uC758 \uD30C\uC6CC\uBD81 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4.</p>\n        </div>\n        ';
            this.wrap.append(scheduleFooter);
        }
    }]);

    return ScheduleTable;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScheduleTable);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var scheduleTableTpl = function () {
    function scheduleTableTpl() {
        _classCallCheck(this, scheduleTableTpl);
    }

    _createClass(scheduleTableTpl, null, [{
        key: 'getTpl',
        value: function getTpl() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var dayOfWeekString = { 1: '월', 2: '화', 3: '수', 4: '목', 5: '금', 6: '토', 7: '일' };
            var weekList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(function (value, index) {
                // today(오늘), selected(현재선택된) 요일 클래스 추가
                return '<li class="' + (index == data.standardDate.dayOfWeek - 1 ? 'today selected' : '') + '"><span>' + value + '</span></li>';
            }).join('');

            console.log('#ScheduleTableTpl.js data : ', data);
            var url = window.location.href;
            return '\n        <div class="schedule-header">\n            <strong class="today">' + data.currentDate.year + '. ' + Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* parseTwoDigits */])(data.currentDate.month) + '. ' + Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* parseTwoDigits */])(data.currentDate.day) + '. (' + dayOfWeekString[data.currentDate.dayOfWeek] + ')</strong>\n            <div class="schedule-header-time">\n                <em class="time">\uD604\uC7AC\uC2DC\uAC04 ' + Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* parseTwoDigits */])(data.currentDate.hour) + ':' + Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* parseTwoDigits */])(data.currentDate.minute) + '</em>\n                <a href="' + url + '" role="button" class="btn-reload"><span class="blind">\uC0C8\uB85C\uACE0\uCE68</span></a>\n            </div>\n        </div>\n        <div class="schedule-table">\n            <div class="schedule-table-head">\n                <ul class="schedule-table-row">\n                    ' + weekList + '\n                </ul>\n            </div>\n            <div class="schedule-table-body">\n                ' + Object.keys(data.objByTime).map(scheduleTableTpl.rowItem, { data: data }).join('') + '\n            </div>\n        </div>';
        }
    }, {
        key: 'rowItem',
        value: function rowItem() {
            var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            // row 데이터 (월~일)
            var parseData = {
                standardDate: this.data.standardDate,
                currentDate: this.data.currentDate,
                objByTime: this.data.objByTime[key]
            };
            return '\n        <ul class="schedule-table-row">\n            ' + Object.keys(parseData.objByTime).map(scheduleTableTpl.colItem, { parseData: parseData }).join('') + '\n        </ul>';
        }
    }, {
        key: 'colItem',
        value: function colItem() {
            var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            // 해당 row 의 한 column (ex. item = 월요일, 시작시간이 10시인 일정)
            var item = this.parseData.objByTime[key];

            return '\n        <li class="schedule-table-col">\n            ' + item.map(scheduleTableTpl.itemInner, {
                parseData: this.parseData,
                key: key
            }).join('') + '\n        </li>';
        }
    }, {
        key: 'itemInner',
        value: function itemInner() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            // 하나의 일정 내부
            var status = '',
                label = '';

            // 현재 요일인 경우
            if (this.key == this.parseData.standardDate.dayOfWeek) {
                var currentTime = this.parseData.currentDate.hour + ':' + this.parseData.currentDate.minute;
                // status = isPassed(data.endTime, currentTime) ? `disabled` : isPassed(data.startTime, currentTime) ? `now` : ``;
                status = Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* getTodayStatus */])(data.startTime, data.endTime, currentTime);
            }

            // 딱지 종류별 DOM
            switch (data.label) {
                case 'hot':
                    label = '<em class="hot-tag"><span class="blind">HOT</span></em>';
                    break;
                case 'new':
                    label = '<em class="new-tag"><span class="blind">NEW</span></em>';
                    break;
                default:
                    label = '';
            }

            return '\n        <a href="' + (data.link ? data.link : '#') + '" class="schedule-element type-' + data.category + ' ' + status + '">\n            <strong class="schedule-title">' + data.name + '</strong>\n            <em class="schedule-time">' + Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* getTimeformat */])(data.startTime) + ' - ' + Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* getTimeformat */])(data.endTime) + '</em>\n            ' + label + '\n        </a>';
        }
    }]);

    return scheduleTableTpl;
}();

/* harmony default export */ __webpack_exports__["a"] = (scheduleTableTpl);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export existy */
/* unused harmony export isDefined */
/* unused harmony export isString */
/* unused harmony export isInteger */
/* unused harmony export isObject */
/* unused harmony export isFunction */
/* unused harmony export not */
/* unused harmony export isNotDef */
/* unused harmony export each */
/* unused harmony export parseInt10 */
/* unused harmony export numberWithCommas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return parseTwoDigits; });
/* unused harmony export isPassed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTodayStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTimeformat; });
/* unused harmony export namespace */
var existy = function existy(obj) {
    return obj != null;
};

var isDefined = function isDefined(obj) {
    var flag = true;
    if (obj === null || typeof obj === 'undefined') return false;
    return flag;
};

var isString = function isString(obj) {
    if (!isDefined(obj)) return false;
    return obj.constructor === String;
};

var isInteger = function isInteger(obj) {
    if (!isDefined(obj) || obj.constructor !== Number) return false;

    // https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
    return isFinite(obj) && Math.floor(obj) === obj;
};

var isObject = function isObject(obj) {
    if (!isDefined(obj)) return false;
    return obj.constructor === Object;
};

var isFunction = function isFunction(obj) {
    if (!isDefined(obj)) return false;
    return obj.constructor === Function;
};

var not = function not(func) {
    if (!isFunction(func)) throw new TypeError('func parameter type of not() must be Function.');

    return function (object) {
        return !func(object);
    };
};

var isNotDef = not(isDefined);

var each = function each(dataCanLoop, func, context) {
    var _context = existy(context) ? context : null;

    if (!(Array.isArray(dataCanLoop) || isString(dataCanLoop))) throw new TypeError('dataCanLoop parameter type of each() must be Array or String.');

    var result = false;
    for (var i = 0, max = dataCanLoop.length; i < max; i++) {
        result = func.call(_context, dataCanLoop[i]);
        if (result === false) break;
    }
};

var parseInt10 = function parseInt10(number) {
    return parseInt(number, 10);
};

var numberWithCommas = function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

var parseTwoDigits = function parseTwoDigits(number) {
    number *= 1;
    return number < 10 ? '0' + number : number;
};

var isPassed = function isPassed(timeA, timeB) {
    var date = new Date();
    var dateA = new Date(date);
    var dateB = new Date(date);
    dateA.setHours(timeA.split(':')[0]);
    dateA.setMinutes(timeA.split(':')[1]);
    dateB.setHours(timeB.split(':')[0]);
    dateB.setMinutes(timeB.split(':')[1]);
    return dateA < dateB;
};

var getTodayStatus = function getTodayStatus(timeA, timeAEnd, timeB) {
    var date = new Date();
    var dateA = new Date(date);
    var dateAEnd = new Date(date);
    var dateB = new Date(date);
    var status = void 0;
    dateA.setHours(timeA.split(':')[0]);
    dateA.setMinutes(timeA.split(':')[1]);

    dateAEnd.setHours(timeAEnd.split(':')[0]);
    dateAEnd.setMinutes(timeAEnd.split(':')[1]);

    // let _timeB = "05:30";
    dateB.setHours(timeB.split(':')[0]);
    dateB.setMinutes(timeB.split(':')[1]);
    // return dateA < dateB;
    if (dateA < dateAEnd) {
        // 익일이 아닌 경우
        status = dateAEnd < dateB ? 'disabled' : dateA < dateB ? 'now' : '';
    } else {
        status = dateA < dateB || dateAEnd > dateB ? 'now' : '';
        console.log('## status : ', status, '/ dateB: ', dateB, '/ dateA: ', dateA, '/ dateAEnd:', dateAEnd);
    }

    return status;
};

var getTimeformat = function getTimeformat(time) {
    var hour = time.split(':')[0] > 24 ? time.split(':')[0] - 24 : time.split(':')[0];
    var minute = time.split(':')[1];

    return parseTwoDigits(hour) + ':' + parseTwoDigits(minute);
};

var namespace = function namespace(_namespace, parent) {
    if (!isString(_namespace)) throw new TypeError('namespace parameter type of namespace() must be String.');
    if (!(isObject(parent) || !isDefined(parent))) throw new TypeError('parent parameter type of namespace() must be Object or null or undefined.');

    var ns = parent || window;

    if (_namespace) {
        var parts = _namespace.split('.');

        for (var i = 0, max = parts.length; i < max; i++) {
            if (!ns[parts[i]]) ns[parts[i]] = {};
            ns = ns[parts[i]];
        }
    }

    return ns;
};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ua */
/* unused harmony export locationOriginRegex */
/* unused harmony export isIE */
/* unused harmony export isEdge */
/* unused harmony export isOpera */
/* unused harmony export isChrome */
/* unused harmony export isIOS */
/* unused harmony export isAndroid */
/* unused harmony export truthy */
/* unused harmony export falsy */
/* unused harmony export existy */
/* unused harmony export isDefined */
/* unused harmony export isRc */
/* unused harmony export isInteger */
/* unused harmony export isString */
/* unused harmony export isNumber */
/* unused harmony export isBoolean */
/* unused harmony export isObject */
/* unused harmony export isFunction */
/* unused harmony export isRegExp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return not; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isNotDefined; });
/* unused harmony export parseInt10 */
/* unused harmony export parseStrIntToInt */
/* unused harmony export removeElementInArray */
/* unused harmony export allOf */
/* unused harmony export anyOf */
/* unused harmony export getDefined */
/* unused harmony export notSingleEle */
/* unused harmony export each */
/* unused harmony export getFileExtension */
/* unused harmony export getFirstObjectHasProperty */
/* unused harmony export getObjectHasProperty */
/* unused harmony export overlappedConditionSortByProperty */
/* unused harmony export getPositionFromTranslateStr */
/* unused harmony export isIndexInLoop */
/* unused harmony export getLoopedLastIndex */
/* unused harmony export getReverseLoopedFirstIndex */
/* unused harmony export getResolution */
/* unused harmony export isPhoneResolution */
/* unused harmony export isTabletResolution */
/* unused harmony export isMobileResolution */
/* unused harmony export numberWithCommas */
/* unused harmony export getUriParams */
/* unused harmony export getUriCombinedParams */
/* unused harmony export getHashParams */
/* unused harmony export getHashCombinedParams */
/* unused harmony export getObjForPagination */
/* unused harmony export getDivideIntStrByThousandUnit */
/* unused harmony export getMarketPriceStr */
/* unused harmony export getEmphasizedStrByQuery */
/* unused harmony export getSeparatedDateStr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return namespace; });
/* unused harmony export template */
/* unused harmony export getUrlAddCategoryIdByArticle */
/* unused harmony export getChangedStats */
/* unused harmony export getPlusElixirPointByLevel */
/* unused harmony export isLevelCanConsumeElixirStat */
/* unused harmony export isLevelGetElixirPoint */
/* unused harmony export getStatMaxByLevel */
/* unused harmony export isWarrior */
/* unused harmony export getClassName */
/* unused harmony export removeEquipInEquips */
/* unused harmony export isPetNecklace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_model__ = __webpack_require__(0);
/*
 * common utils
 */



var ua = window.navigator.userAgent;

var locationOriginRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})/;

var isIE = function () {
  return (/msie/i.test(ua) || /trident/i.test(ua)
  );
}();

var isEdge = function isEdge(userAgent) {
  return (/Gecko/i.test(userAgent) && /Edge/i.test(userAgent)
  );
};

var isOpera = function isOpera(userAgent) {
  return (/Opera/i.test(userAgent) || /OPR\//i.test(userAgent)
  );
};

var isChrome = function isChrome(userAgent) {
  return !isEdge(userAgent) && !isOpera(userAgent) && /Chrome/i.test(userAgent);
};

var isIOS = function isIOS(userAgent) {
  return (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  );
};

var isAndroid = function isAndroid(userAgent) {
  return (/android/i.test(userAgent)
  );
};

var truthy = function truthy(object) {
  return !!object;
};

var falsy = function falsy(object) {
  return !!!object;
};

var existy = function existy(obj) {
  return obj != null;
};

var isDefined = function isDefined(obj) {
  var flag = true;
  if (obj === null || typeof obj === 'undefined') return false;
  return flag;
};

var isRc = function () {
  return isDefined(/^rc-/.exec(location.hostname));
}();

var isInteger = function isInteger(obj) {
  if (!isDefined(obj) || obj.constructor !== Number) return false;

  // https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
  return isFinite(obj) && Math.floor(obj) === obj;
};

var isString = function isString(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === String;
};

var isNumber = function isNumber(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Number;
};

var isBoolean = function isBoolean(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Boolean;
};

var isObject = function isObject(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Object;
};

var isFunction = function isFunction(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Function;
};

var isRegExp = function isRegExp(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === RegExp;
};

var not = function not(func) {
  if (!isFunction(func)) throw new TypeError('func parameter type of not() must be Function.');

  return function (object) {
    return !func(object);
  };
};

var isNotDefined = not(isDefined);

var parseInt10 = function parseInt10(number) {
  return parseInt(number, 10);
};

var parseStrIntToInt = function parseStrIntToInt(strIntOrInt) {
  var val = strIntOrInt;

  if (!isDefined(val)) return 0;
  if (typeof val === 'number') return val;

  return parseInt10(val.split(',').join(''));
};

var removeElementInArray = function removeElementInArray(arr, target) {
  if (!Array.isArray(arr)) throw new TypeError('arr parameter type of removeElementInArray() must be Array.');

  var clonedArr = arr.slice(0),
      index = clonedArr.indexOf(target);

  if (index >= 0) clonedArr.splice(index, 1);

  return clonedArr;
};

var allOf = function allOf() /*args*/{
  var args = Array.prototype.slice.call(arguments);

  return args.every(function (val) {
    return val === true;
  });
};

var anyOf = function anyOf() /*args*/{
  var args = Array.prototype.slice.call(arguments);

  return args.some(function (val) {
    return val === true;
  });
};

var getDefined = function getDefined(val, defaultVal) {
  return isDefined(val) ? val : defaultVal;
};

var notSingleEle = not(function ($ele) {
  return $ele.length === 1;
});

var each = function each(dataCanLoop, func, context) {
  var _context = existy(context) ? context : null;

  if (!(Array.isArray(dataCanLoop) || isString(dataCanLoop))) throw new TypeError('dataCanLoop parameter type of each() must be Array or String.');

  var result = false;
  for (var i = 0, max = dataCanLoop.length; i < max; i++) {
    result = func.call(_context, dataCanLoop[i]);
    if (result === false) break;
  }
};

var getFileExtension = function getFileExtension(fileName) {
  if (!isString(fileName)) throw new TypeError('getFileExtension() requires String parameter.');

  if (fileName.length <= 0) return '';

  var lastDotIndex = fileName.lastIndexOf('.'),
      extension = fileName.substr(lastDotIndex + 1);

  return extension;
};

var getFirstObjectHasProperty = function getFirstObjectHasProperty(arrayHasObjects, propertyKey, findPropertyValueOrRegex) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;

  var obj = void 0,
      result = null;
  for (var i = 0, max = arrayHasObjects.length; i < max; ++i) {
    obj = arrayHasObjects[i];
    if (!obj.hasOwnProperty(propertyKey)) continue;

    if (isRegExp(findPropertyValueOrRegex)) {
      if (findPropertyValueOrRegex.test(obj[propertyKey])) {
        result = obj;
        break;
      }
    } else {
      if (obj[propertyKey] === findPropertyValueOrRegex) {
        result = obj;
        break;
      }
    }
  }
  return result;
};

var getObjectHasProperty = function getObjectHasProperty(arrayHasObjects, propertyKey) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;
  var obj = void 0,
      result = null;

  each(arrayHasObjects, function (obj) {
    if (obj.hasOwnProperty(propertyKey)) result = obj[propertyKey];
  });
  //  console.log( '=> util.js getObjectHasProperty() result : ', propertyKey, result );
  return result;
};

var overlappedConditionSortByProperty = function sortByProp(_datas, _conditions, _conditionIndex) {
  var datas = Array.prototype.slice.call(_datas);

  if (!_conditions || _conditions.constructor !== Array || _conditions.length < 0) return datas;

  var conditionIndex = _conditionIndex >= 0 ? _conditionIndex : 0,
      condition = _conditions[conditionIndex];

  if (conditionIndex <= 0) datas.sort(condition.func);

  if (_conditions.length <= 1) return datas;

  if (conditionIndex < _conditions.length - 1) {
    var prevProperty = condition.property,
        nextConditionIndex = conditionIndex + 1,
        nextCondition = _conditions[nextConditionIndex];

    var memoObj = {},
        memoArr = [],
        arr = [];

    var obj = void 0,
        prop = void 0;
    for (var i = 0, max = datas.length; i < max; i++) {
      obj = datas[i];
      prop = String(obj[prevProperty]);

      if (!memoObj[prop]) {
        memoObj[prop] = [];
        memoArr.push(memoObj[prop]);
      }

      arr = memoObj[prop];
      arr.push(obj);
    }

    for (var j = 0, len = memoArr.length; j < len; j++) {
      arr = memoArr[j];
      arr.sort(nextCondition.func);

      memoArr[j] = overlappedConditionSortByProperty(arr, _conditions, nextConditionIndex);
    }

    var resultArr = memoArr.reduce(function (acc, curVal, curIndex, array) {
      return acc.concat(curVal);
    });

    return resultArr;
  }

  return datas;
};

var getPositionFromTranslateStr = function getPositionFromTranslateStr(str) {
  var obj = { x: 0, y: 0 };
  if (!isDefined(str)) return obj;

  var values = str.match(/[+-]?(\d*\.)?\d+/g);
  if (values.length <= 0) return obj;

  if (/translateX/g.test(str)) {
    obj.x = parseFloat(values[0]);
    return obj;
  }

  if (/translateY/g.test(str)) {
    obj.y = parseFloat(values[0]);
    return obj;
  }

  obj.x = parseFloat(values[0]);
  if (values.length > 1) obj.y = parseFloat(values[1]);

  return obj;
};

var isIndexInLoop = function isIndexInLoop(totalLength, loopGap, firstIndex, searchIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 4) throw Error('isIndexInLoop function requires 4 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex) || !isInteger(searchIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and startIndex can not smaller than 1.');
  }
  if (loopGap > totalLength) {
    throw Error('loopGap can not bigger than totalLength.');
  }

  var index = firstIndex;
  for (var i = 0; i < loopGap; i++) {
    if (index === searchIndex) return true;
    index = index + 1 > totalLength ? 1 : index + 1;
  }

  return false;
};

var getLoopedLastIndex = function getLoopedLastIndex(totalLength, loopGap, firstIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getLoopedLastIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and firstIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || firstIndex > totalLength) {
    throw Error('loopGap and firstIndex can not bigger than totalLength.');
  }

  var index = firstIndex;
  for (var i = 0; i < loopGap - 1; i++) {
    index++;
    if (index > totalLength) index = 1;
  }
  return index;
};

var getReverseLoopedFirstIndex = function getReverseLoopedFirstIndex(totalLength, loopGap, lastIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getReverseLoopedFirstIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(lastIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || lastIndex < 1) {
    throw Error('totalLength and lastIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || lastIndex > totalLength) {
    throw Error('loopGap and lastIndex can not bigger than totalLength.');
  }

  var index = lastIndex;
  for (var i = 0; i < loopGap - 1; i++) {
    index = index - 1 < 1 ? totalLength : index - 1;
  }

  return index;
};

var getResolution = function getResolution() {
  var breakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { tablet: 640, pc: 960, max: 1260 };
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  var resolution = '';
  if (breakpoint.max && global.innerWidth >= breakpoint.max) {
    resolution = 'max';
  } else if (breakpoint.pc && global.innerWidth >= breakpoint.pc) {
    resolution = 'pc';
  } else if (breakpoint.tablet && global.innerWidth >= breakpoint.tablet) {
    resolution = 'tablet';
  } else {
    resolution = 'phone';
  }

  return resolution;
};

var isPhoneResolution = function isPhoneResolution(resolution) {
  return resolution === 'phone';
};

var isTabletResolution = function isTabletResolution(resolution) {
  return resolution === 'tablet';
};

var isMobileResolution = function isMobileResolution(resolution) {
  return resolution === 'phone' || resolution === 'tablet';
};

// http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
var numberWithCommas = function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var getUriParams = function getUriParams(uri) {
  if (uri.length < 1) return null;
  var str = uri.split('#')[0];

  var tmpArr = str.split('?');
  if (tmpArr.length < 2) return null;

  var paramStr = tmpArr[1],
      params = paramStr.split('&');

  var keyValueArr = void 0,
      obj = {};
  for (var i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length > 1) obj[keyValueArr[0]] = keyValueArr[1];

    // if (keyValueArr.length <= 1) return null;
    // obj[keyValueArr[0]] = keyValueArr[1];
  }
  return obj;
};

var getUriCombinedParams = function getUriCombinedParams(uri, params) {
  if (!uri) return '';
  if (!params) return uri;

  var str = '';
  for (var key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  var tmpArr = uri.split('#'),
      uri = tmpArr[0],
      hashStr = isDefined(tmpArr[1]) ? '#' + tmpArr[1] : '';

  uri = (uri.indexOf('?') >= 0 ? uri + str : uri + '?' + str.substr(1)) + hashStr;
  return uri;
};

var getHashParams = function getHashParams(hashStr) {
  var str = hashStr;
  if (str.length < 1) return null;

  var tmpArr = str.split('#');
  if (tmpArr.length < 2) return null;

  var paramStr = tmpArr[1],
      params = paramStr.split('&');

  var keyValueArr = void 0,
      obj = {};
  for (var i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length <= 1) return null;

    obj[keyValueArr[0]] = keyValueArr[1];
  }

  return obj;
};

var getHashCombinedParams = function getHashCombinedParams(uri, params) {
  if (!params) return uri;

  var str = '';
  for (var key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  uri = uri.indexOf('#') >= 0 ? uri + str : uri + '#' + str.substr(1);
  return uri;
};

var getObjForPagination = function getObjForPagination(totalPostNum, displayPostNumPerPage, displayPaginationBtnNum, pageIndex) {
  var args = Array.prototype.slice.call(arguments);

  if (args.length < 4) throw new Error('getObjForPagination() requires 4 parameters.');

  if (!isInteger(totalPostNum) || !isInteger(displayPostNumPerPage) || !isInteger(displayPaginationBtnNum) || !isInteger(pageIndex)) {
    throw new TypeError('getObjForPagination() requires Integer Number parameters.');
  }
  if (totalPostNum <= 0 || displayPostNumPerPage <= 0 || displayPaginationBtnNum <= 0 || pageIndex <= 0) {
    throw new TypeError('getObjForPagination() requires positive Integer Number parameters.');
  }

  var totalPageNum = Math.ceil(totalPostNum / displayPostNumPerPage);
  if (pageIndex < 1) pageIndex = 1;
  if (pageIndex > totalPageNum) pageIndex = totalPageNum;

  var paginationBtnGroupIndex = Math.floor((pageIndex - 1) / displayPaginationBtnNum),
      prevPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum,
      firstPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum + 1,
      lastPageIndex = firstPageIndex + displayPaginationBtnNum - 1,
      nextPageIndex = lastPageIndex + 1;

  if (lastPageIndex > totalPageNum) lastPageIndex = totalPageNum;
  if (nextPageIndex > totalPageNum) nextPageIndex = 0;

  return {
    totalPostNum: totalPostNum,
    displayPostNumPerPage: displayPostNumPerPage,
    displayPaginationBtnNum: displayPaginationBtnNum,
    pageIndex: pageIndex,

    totalPageNum: totalPageNum,
    prevPageIndex: prevPageIndex,
    firstPageIndex: firstPageIndex,
    lastPageIndex: lastPageIndex,
    nextPageIndex: nextPageIndex
  };
};

var getDivideIntStrByThousandUnit = function getDivideIntStrByThousandUnit(intStr_) {
  if (not(isDefined)(intStr_)) return ['0'];

  var DIVIDE_UNIT = 4;

  var intStr = String(parseStrIntToInt(intStr_)),
      intStrs = [];

  if (intStr.length <= DIVIDE_UNIT) return [String(intStr)];

  var lastIndex = 0,
      unitStr = '';
  while (intStr.length > DIVIDE_UNIT) {
    lastIndex = intStr.length;
    unitStr = intStr.substr(lastIndex - DIVIDE_UNIT, lastIndex);

    intStr = intStr.substr(0, lastIndex - DIVIDE_UNIT);
    intStrs.unshift(unitStr);
  }
  intStrs.unshift(intStr);

  return intStrs;
};

var getMarketPriceStr = function getMarketPriceStr(str) {
  var UNIT_PRICE = ['', '만', '억'];

  var val = isDefined(str) ? str : '0',
      unitValues = getDivideIntStrByThousandUnit(val);

  unitValues.reverse();

  var priceStr = '',
      unitVal = 0;
  for (var i = 0, max = unitValues.length; i < max; i++) {
    unitVal = parseInt10(unitValues[i]);
    if (unitVal <= 0) continue;

    priceStr = numberWithCommas(unitVal) + UNIT_PRICE[i] + priceStr;
    if (i !== unitValues.length) priceStr = ' ' + priceStr;
  }
  priceStr = priceStr.trim();

  if (!priceStr) return '0';
  return priceStr;
};

var getEmphasizedStrByQuery = function getEmphasizedStrByQuery(str, query) {
  return (str || '').split(query).join('<strong>' + query + '</strong>');
};

var getSeparatedDateStr = function getSeparatedDateStr(moment, dateStr) {
  var DAYS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    'Sunday': '일',
    'Monday': '월',
    'Tuesday': '화',
    'Wednesday': '수',
    'Thursday': '목',
    'Friday': '금',
    'Saturday': '토'
  };

  var val = '';

  var MIN_TO_SEC = 60,
      HOUR_TO_SEC = 3600,
      DAY_TO_SEC = 86400;

  var now = new Date(),
      past = new Date(dateStr),
      diffSeconds = Math.floor((now - past) / 1000);

  if (diffSeconds < DAY_TO_SEC) {
    if (diffSeconds < HOUR_TO_SEC) {
      if (diffSeconds < MIN_TO_SEC) {
        val = diffSeconds + '\uCD08 \uC804';
      } else {
        var diffMinutes = Math.floor(diffSeconds / MIN_TO_SEC);
        val = diffMinutes + '\uBD84 \uC804';
      }
    } else {
      var diffHours = Math.floor(diffSeconds / HOUR_TO_SEC);
      val = diffHours + '\uC2DC\uAC04 \uC804';
    }
  } else {
    var date = moment(dateStr),
        day = DAYS[date.format('dddd')] || '';

    val = date.format('YYYY-MM-DD');
    // val = date.format(`YYYY.MM.DD. (${day})`);
  }

  return val;
};

var namespace = function namespace(_namespace, parent) {
  if (!isString(_namespace)) throw new TypeError('namespace parameter type of namespace() must be String.');
  if (!(isObject(parent) || !isDefined(parent))) throw new TypeError('parent parameter type of namespace() must be Object or null or undefined.');

  var ns = parent || window;

  if (_namespace) {
    var parts = _namespace.split('.');

    for (var i = 0, max = parts.length; i < max; i++) {
      if (!ns[parts[i]]) ns[parts[i]] = {};
      ns = ns[parts[i]];
    }
  }

  return ns;
};

var template = function template(strings) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
  return function () {
    for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      values[_key2] = arguments[_key2];
    }

    var dict = values[values.length - 1] || {};

    var result = [strings[0]];
    keys.forEach(function (key, i) {
      var value = Number.isInteger(key) ? values[key] : dict[key];
      result.push(value, strings[i + 1]);
    });

    return result.join('');
  };
};

// board - server list
var getUrlAddCategoryIdByArticle = function getUrlAddCategoryIdByArticle(_url, _article, _serverNameMap) {
  var url = _url;

  if (url !== '#') {
    var path = url.split('?')[0],
        uriParams = getUriParams(url);

    var categoryId = isObject(_article.category) ? _article.category.categoryId : uriParams.categoryId;

    if (isNotDefined(categoryId)) {
      // const obj = getFirstObjectHasProperty(_serverNameMap, 'serverId', 1) || _serverNameMap[0];
      // categoryId = obj.categoryId;
      categoryId = 0;
    }

    url = getUriCombinedParams(path, $.extend(uriParams, { categoryId: categoryId }));
  }

  return url;
};

// character setting - stat, equip simulator
var getChangedStats = function getChangedStats(originalStatObj, newStatObj) {
  var changedStats = {};

  var stat, newStat;
  for (var key in originalStatObj) {
    stat = isDefined(originalStatObj[key]) ? originalStatObj[key] : null;
    newStat = isDefined(newStatObj[key]) ? newStatObj[key] : null;

    if (allOf(isDefined(newStat), stat !== newStat)) changedStats[key] = newStat;
  }

  var changeStatsCount = 0;
  for (var k in changedStats) {
    changeStatsCount++;
  }return changeStatsCount > 0 ? changedStats : null;
};

// 2021.12 [StatModel.js] STEP_ELIXIR_POINT_BY_LEVEL = [{level: 80, point: 2 }, {level: 90, point: 2}, {level: 100, point: 3 }];
var getPlusElixirPointByLevel = function getPlusElixirPointByLevel(level, level_init, plusElixirPointByLevel) {
  var _plusElixirPoint = 0;
  if ((level - level_init) % 2 === 0) {
    _plusElixirPoint = 1;
  }
  each(plusElixirPointByLevel, function (obj) {
    if (parseInt(obj.level) === parseInt(level)) {
      _plusElixirPoint = parseInt(obj.point);
    }
  });
  // console.log( '=> util.js  _plusElixirPoint : ', _plusElixirPoint );
  return _plusElixirPoint;
};

// 2019.11 엘릭서를 사용할 수 없는 레벨 체크 50 이상이면 가능함 _.statData.level - _.model.LEVEL_INIT
var isLevelCanConsumeElixirStat = function isLevelCanConsumeElixirStat(level, perLevelPlusElixirPoint) {
  return level >= 0 ? true : false;
  // return (level % perLevelPlusElixirPoint === 0) ? true : false;
};

var isLevelGetElixirPoint = function isLevelGetElixirPoint(level, perLevelPlusElixirPoint) {
  // 2019.11
  return level % perLevelPlusElixirPoint === 0 ? true : false;
};

// STAT_MAX_BY_LEVEL 2021.
var getStatMaxByLevel = function getStatMaxByLevel(level, statMaxByLevel) {
  var _statMax = 50;
  each(statMaxByLevel, function (obj) {
    if (parseInt(obj.level) <= level) {
      _statMax = parseInt(obj.max);
    }
  });
  // console.log( '=> util.js getStatMaxByLevel() _statMax : ', _statMax );
  return _statMax;
};

var isWarrior = function isWarrior(classId) {
  if (parseInt10(classId) === 7) return true;

  return false;
};

var getClassName = function getClassName(classId) {
  var CLASS_NAMES_KOR = ['군주', '기사', '요정', '마법사', '다크엘프', '용기사', '환술사', '전사', '검사', '창기사'];

  var className = CLASS_NAMES_KOR[parseInt10(classId)];
  if (not(isDefined)(className)) className = '';

  return className;
};

var removeEquipInEquips = function removeEquipInEquips(equips, equipItemObj) {
  if (!Array.isArray(equips)) throw new TypeError('arr parameter type of removeEquipInEquips() must be Array.');

  var clonedEquips = equips.slice();

  var equip = void 0;
  for (var i = 0, max = clonedEquips.length; i < max; i++) {
    equip = clonedEquips[i];

    if (allOf(isDefined(equip), equip.id === equipItemObj.id, equip.name === equipItemObj.name, equip.slot === equipItemObj.slot)) {
      clonedEquips.splice(i, 1);
      break;
    }
  }

  return clonedEquips;
};

var isPetNecklace = function isPetNecklace(itemId) {
  return itemId === __WEBPACK_IMPORTED_MODULE_0__model_model__["a" /* PET_NECKLACE_ID */] ? true : false;
};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDatas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDatasWithOption; });
/* unused harmony export handleApiError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_msg_alert__ = __webpack_require__(8);


var getDatas = function getDatas(urls, resolvedCallback, rejectedCallback) {
  var promises = [];

  for (var i = 0, max = urls.length; i < max; i++) {
    var promise = $.ajax({
      type: 'GET',
      url: urls[i],
      dataType: 'json'
    });
    promises.push(promise);
  }

  $.when.apply($, promises).then(resolvedCallback).fail(rejectedCallback);
};

var getDatasWithOption = function getDatasWithOption(jQueryAjaxOptions, resolvedCallback, rejectedCallback) {
  var promises = [];

  for (var i = 0, max = jQueryAjaxOptions.length; i < max; i++) {
    var promise = $.ajax(jQueryAjaxOptions[i]);
    promises.push(promise);
  }

  $.when.apply($, promises).then(resolvedCallback).fail(rejectedCallback);
};

var handleApiError = function handleApiError(apiResultData) {
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  if (apiResultData) {
    if (parseInt(apiResultData.status, 10) === 401) {
      // http://git.korea.ncsoft.corp/projects/FRONTEND_DEVELOP/repos/uikit-nccommunity/browse/_src/js/lang.js
      global.alert(__WEBPACK_IMPORTED_MODULE_0__model_msg_alert__["a" /* ALERT */].REQUIRE_LOGIN);

      if (typeof global.GNBLogin === 'function') {
        global.GNBLogin();

        return true;
      }
    }
  }

  return false;
};



/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALERT; });
var ALERT = {
  REQUIRE_LOGIN: '로그인 후 이용하실 수 있습니다.'
};



/***/ })
/******/ ]);


// WEBPACK FOOTER //
// schedule/schedule.js